<template>
  <div>

    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 post-list blog-post-list">
            <div class="single-post">
              <img class="img-fluid" src="static/assets/images/p1.jpg" alt="">
              <ul class="tags">
                <li><a href="#">Art, </a></li>
                <li><a href="#">Technology, </a></li>
                <li><a href="#">Fashion</a></li>
              </ul>
              <a href="blog-single.html">
                <h2>
                  Cartridge Is Better Than Ever
                  A Discount Toner
                </h2>
              </a>
              <p>
                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
              </p>
              <div class="bottom-meta">
                <div class="user-details row align-items-center">
                  <div class="comment-wrap col-lg-6">
                    <ul>
                      <li><a href="#"><span class="lnr lnr-heart"></span>	4 likes</a></li>
                      <li><a href="#"><span class="lnr lnr-bubble"></span> 06 Comments</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-post">
              <img class="img-fluid" src="static/assets/images/p2.jpg" alt="">
              <ul class="tags">
                <li><a href="#">Art, </a></li>
                <li><a href="#">Technology, </a></li>
                <li><a href="#">Fashion</a></li>
              </ul>
              <a href="blog-single.html">
                <h2>
                  Cartridge Is Better Than Ever
                  A Discount Toner
                </h2>
              </a>
              <p>
                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
              </p>
              <div class="bottom-meta">
                <div class="user-details row align-items-center">
                  <div class="comment-wrap col-lg-6">
                    <ul>
                      <li><a href="#"><span class="lnr lnr-heart"></span>	4 likes</a></li>
                      <li><a href="#"><span class="lnr lnr-bubble"></span> 06 Comments</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-post">
              <img class="img-fluid" src="static/assets/images/p3.jpg" alt="">
              <ul class="tags">
                <li><a href="#">Art, </a></li>
                <li><a href="#">Technology, </a></li>
                <li><a href="#">Fashion</a></li>
              </ul>
              <a href="blog-single.html">
                <h2>
                  Cartridge Is Better Than Ever
                  A Discount Toner
                </h2>
              </a>
              <p>
                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
              </p>
              <div class="bottom-meta">
                <div class="user-details row align-items-center">
                  <div class="comment-wrap col-lg-6">
                    <ul>
                      <li><a href="#"><span class="lnr lnr-heart"></span>	4 likes</a></li>
                      <li><a href="#"><span class="lnr lnr-bubble"></span> 06 Comments</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="single-post">
              <img class="img-fluid" src="static/assets/images/p4.jpg" alt="">
              <ul class="tags">
                <li><a href="#">Art, </a></li>
                <li><a href="#">Technology, </a></li>
                <li><a href="#">Fashion</a></li>
              </ul>
              <a href="blog-single.html">
                <h2>
                  Cartridge Is Better Than Ever
                  A Discount Toner
                </h2>
              </a>
              <p>
                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
              </p>
              <div class="bottom-meta">
                <div class="user-details row align-items-center">
                  <div class="comment-wrap col-lg-6">
                    <ul>
                      <li><a href="#"><span class="lnr lnr-heart"></span>	4 likes</a></li>
                      <li><a href="#"><span class="lnr lnr-bubble"></span> 06 Comments</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 sidebar">
            <div class="single-widget search-widget">
              <form class="example" action="#" style="margin:auto;max-width:300px">
                <input type="text" placeholder="Search Posts" name="search2" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Search Posts'" required>
                <button type="submit"><i class="fa fa-search"></i></button>
              </form>
            </div>

            <div class="single-widget protfolio-widget">
              <img src="static/assets/images/user2.jpg" alt="">
              <a href="#"><h4>Adele Gonzalez</h4></a>
              <p>
                MCSE boot camps have its supporters and
                its detractors. Some people do not understand why you should have to spend money
                on boot camp.
              </p>
              <ul>
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                <li><a href="#"><i class="fa fa-behance"></i></a></li>
              </ul>
            </div>

            <div class="single-widget category-widget">
              <h4 class="title">Post Categories</h4>
              <ul>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Techlology</h6> <span>37</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Lifestyle</h6> <span>24</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Fashion</h6> <span>59</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Art</h6> <span>29</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Food</h6> <span>15</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Architecture</h6> <span>09</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Adventure</h6> <span>44</span></a></li>
              </ul>
            </div>

            <div class="single-widget recent-posts-widget">
              <h4 class="title">Recent Posts</h4>
              <div class="blog-list ">
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r1.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r2.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r3.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r4.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="single-widget category-widget">
              <h4 class="title">Post Archive</h4>
              <ul>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Dec '17</h6> <span>37</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Nov '17</h6> <span>24</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Oct '17</h6> <span>59</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Sep '17</h6> <span>29</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Aug '17</h6> <span>15</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Jul '17</h6> <span>09</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Jun '17</h6> <span>44</span></a></li>
              </ul>
            </div>

            <div class="single-widget tags-widget">
              <h4 class="title">Tag Clouds</h4>
              <ul>
                <li><a href="#">Lifestyle</a></li>
                <li><a href="#">Art</a></li>
                <li><a href="#">Adventure</a></li>
                <li><a href="#">Food</a></li>
                <li><a href="#">Techlology</a></li>
                <li><a href="#">Fashion</a></li>
                <li><a href="#">Architecture</a></li>
                <li><a href="#">Food</a></li>
                <li><a href="#">Technology</a></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// src/pages/BlogHome.vue